module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tree', {
    staticClass: "smart-tree",
    attrs: {
      "show-checkbox": "show-checkbox",
      "node-key": "value",
      "accordion": true,
      "data": _vm.treeData,
      "default-checked-keys": Array.from(_vm.currentValue)
    },
    on: {
      "node-click": _vm.treeNodeClick,
      "check-change": _vm.treeChangeValue
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd9de9c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmartForm/SmartFormItem/SmartTree.vue
// module id = 1809
// module chunks = 1